import { Helmet } from 'react-helmet-async'

export function Terms() {
  return (
    <div className="py-12 px-4">
      <Helmet>
        <title>Terms of Service | VaultLynk</title>
        <meta name="description" content="Read the VaultLynk Terms of Service. Learn about acceptable use, file storage policies, and subscription terms." />
      </Helmet>
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>

        <div className="prose prose-gray max-w-none">
          <p className="text-gray-600 mb-6">
            Last updated: February 6, 2026
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 mb-4">
              By accessing or using VaultLynk ("Service"), you agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use our Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
            <p className="text-gray-600 mb-4">
              VaultLynk provides a file sharing service that allows users to upload, store, and share files
              through secure, expiring links. We offer both free and paid subscription tiers with varying
              features and limits.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. User Accounts</h2>
            <p className="text-gray-600 mb-4">
              To access certain features, you may need to create an account. You are responsible for:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized use</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Acceptable Use</h2>
            <p className="text-gray-600 mb-4">
              You agree not to use VaultLynk to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
              <li>Upload, share, or distribute illegal content</li>
              <li>Share copyrighted material without authorization</li>
              <li>Distribute malware, viruses, or harmful code</li>
              <li>Share content that violates others' privacy or rights</li>
              <li>Engage in any activity that disrupts the Service</li>
              <li>Attempt to gain unauthorized access to our systems</li>
            </ul>
            <p className="text-gray-600 mb-4">
              We reserve the right to remove any content and terminate accounts that violate these terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. File Storage and Expiration</h2>
            <p className="text-gray-600 mb-4">
              Files uploaded to VaultLynk are subject to automatic expiration based on your subscription tier:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
              <li>Free tier: Files expire after 24 hours</li>
              <li>Premium tier: Files expire after 30 days</li>
              <li>Business tier: Files expire after 90 days</li>
            </ul>
            <p className="text-gray-600 mb-4">
              Expired files are permanently deleted and cannot be recovered.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Subscription and Payments</h2>
            <p className="text-gray-600 mb-4">
              Paid subscriptions are billed monthly through Stripe. By subscribing, you authorize us to
              charge your payment method on a recurring basis. You may cancel your subscription at any time,
              and you will retain access until the end of your billing period.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-600 mb-4">
              VaultLynk is provided "as is" without warranties of any kind. We are not liable for any
              data loss, damages, or issues arising from your use of the Service. You are responsible
              for maintaining backups of your important files.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Changes to Terms</h2>
            <p className="text-gray-600 mb-4">
              We may update these Terms of Service from time to time. Continued use of the Service
              after changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Contact</h2>
            <p className="text-gray-600 mb-4">
              If you have questions about these Terms, please contact us at support@vaultlynk.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
